module.exports = __webpack_public_path__ + "img/sponsor-04.c6a1c3e2.png";